import React from 'react';
import './MultiUnitLoader.less';

const MultiUnitLoader = ({multiUnitDataCount}) => {
    let loader = Array.from({length: multiUnitDataCount}, (e, index) => (
        <li className="MultiUnitItem--skeleton" key={index}>
            <div className="MultiUnitItemImage">
                <div className="MultiUnitItemImage__image-div" />
            </div>
            <div className="MultiUnitItem__content">
                <div className="MultiUnitItem__content-row">
                    <div className="MultiUnitItem__skeleton MultiUnitItem__skeleton--16" />
                </div>
                <div className="MultiUnitItem__content-row">
                    <div className="MultiUnitItem__skeleton MultiUnitItem__skeleton--16" />
                </div>
                <div className="MultiUnitItem__content-row MultiUnitItem__content-row--price-ratings">
                    <div className="MultiUnitItem__skeleton MultiUnitItem__skeleton--24" />
                    <div className="MultiUnitItem__skeleton MultiUnitItem__skeleton--22" />
                </div>
            </div>
        </li>
    ));
    return <div className="MultiUnit__dropdown--loading">{loader}</div>;
};

export default MultiUnitLoader;
